import style from "./SignUpContainer.module.scss"
import {Navigate, Route, Routes} from "react-router-dom";
import React from "react";
import {RouteInfo} from "../../../route/RouteHelper";
import IntroductionVideo from "../../../pages/SignUpPages/IntroductionVideo/IntroductionVideo";
import SellerType from "../../../pages/SignUpPages/sellerType/SellerType";
import {css} from "@emotion/css";
import LegalPerson from "../../seller/legalPerson/LegalPerson";

export default function SignUpContainer() {
    return (
        <div className={style.signUpLayout}>
            <div className={style.signUpContainer}>
                <Routes>
                    <Route element={<IntroductionVideo/>} path={RouteInfo.SignUpIntro.url}/>
                    <Route element={<SellerType/>} path={RouteInfo.SignUpSellerType.url}/>
                    <Route element={<LegalPerson/>} path={RouteInfo.LegalPerson.url}/>

                    <Route path="/*" element={<Navigate replace to={RouteInfo.SignUpIntro.url}/>}/>
                </Routes>
            </div>

        </div>
    )

}